import axios from "axios";
import { CreateCommunityModel } from "../../datamodels/onboarding/createCommunityModel";

export async function createCommunityApiCall(
  passedName: string,
  passedDomain: String,
  isPrivate: boolean,
  passedToken: string | null
) {
  const response = await axios.post<CreateCommunityModel>(
    `/community/Organization/v2/Create`,
    {
      organizationName: passedName,
      communitySubDomain: passedDomain,
      marketPlace: isPrivate ? "PRIVATE" : "COMMUNITY",
      recaptchaResponse: passedToken,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        Authorization: `${localStorage.getItem(
          "@JWTTokenType"
        )} ${localStorage.getItem("@JWTToken")}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}
